import { inject } from "@angular/core";
import type { CanActivateFn } from "@angular/router";
import { NotificationsRoutingFacade } from "../domain/+state/notifications-routing-facade.service";

export const verificationGuard: CanActivateFn = (route) => {
	const notificationFacade = inject(NotificationsRoutingFacade);
	const { tx_pid, address_book_id } = route.queryParams;

	if (tx_pid && address_book_id) {
		notificationFacade.openVerificationOnHoldModal(tx_pid, address_book_id);
		return true;
	}

	return false;
};
